<template>
  <modal @close="closeModal" ref="modal">
    <template slot="header">
      <step :label="i18n.steps.labels.payment" :step="3" :final="true"></step>
    </template>
    <template slot="main">
      <pay-refill
        v-if="this.existingRefill !== undefined"
        :refill="existingRefill"
        @payment-success="onPaymentSuccess"
      ></pay-refill>
    </template>
  </modal>
</template>

<script>
import Modal from "../Design/Modal";
import Step from "../Design/Stepper/Step";
import PayRefill from "./PayRefill";

export default {
  props: ["existingRefill"],
  components: {
    Modal,
    Step,
    PayRefill,
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },

    onPaymentSuccess(invoiceId) {
      this.$store.dispatch("safe/getDetail", invoiceId);
      this.$store.dispatch("account/updateSafe");
    },
  },
  computed: {
    form() {
      return this.$store.state.safe.form;
    },

    i18n() {
      return this.$store.state.safe.i18n.new_refill;
    },
  },
  mounted() {
    if (this.form === undefined) {
      this.$store.commit("safe/setForm", this.$store.state.account.contact);
    }
  },
};
</script>
